module.exports = __webpack_public_path__ + "static/media/OgKvT1024267_sm2.4b5f3dae.png";